var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        title: "对账单列表导出记录",
        width: "95%",
        top: "5vh",
        "append-to-body": "",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        { staticClass: "record-filter", attrs: { inline: "", size: "small" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "任务名称：" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入任务名称" },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.handleSearch($event)
                  },
                },
                model: {
                  value: _vm.query.taskName,
                  callback: function ($$v) {
                    _vm.$set(_vm.query, "taskName", $$v)
                  },
                  expression: "query.taskName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "任务状态：" } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", placeholder: "请选择" },
                  model: {
                    value: _vm.query.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.query, "status", $$v)
                    },
                    expression: "query.status",
                  },
                },
                _vm._l(_vm.statusOptions, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "创建时间：" } },
            [
              _c("el-date-picker", {
                attrs: {
                  type: "datetimerange",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  "default-time": ["00:00:00", "23:59:59"],
                  "start-placeholder": "开始时间",
                  "end-placeholder": "结束时间",
                  "range-separator": "至",
                  clearable: "",
                },
                model: {
                  value: _vm.createTimeRange,
                  callback: function ($$v) {
                    _vm.createTimeRange = $$v
                  },
                  expression: "createTimeRange",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSearch } },
                [_vm._v("搜索")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.handleReset } }, [
                _vm._v("重置"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-refresh" },
                  on: { click: _vm.fetchList },
                },
                [_vm._v("刷新")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            data: _vm.list,
            border: "",
            stripe: "",
            size: "small",
            "max-height": "580",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "taskName",
              label: "任务名称",
              "min-width": "180",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "状态", width: "150", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.statusTagType(scope.row.status),
                          size: "small",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            scope.row.statusName ||
                              _vm.statusText(scope.row.status)
                          )
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    scope.row.status === "WAITING" && scope.row.queuePosition
                      ? _c("div", { staticClass: "queue-position" }, [
                          _vm._v(
                            "第 " + _vm._s(scope.row.queuePosition) + " 位"
                          ),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "进度", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-progress", {
                      attrs: {
                        percentage: _vm.getProgress(scope.row),
                        status:
                          scope.row.status === "COMPLETED"
                            ? "success"
                            : undefined,
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "文件", "min-width": "210" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [_vm._v(_vm._s(scope.row.fileName || "-"))]),
                    _vm._v(" "),
                    scope.row.fileSizeStr
                      ? _c("div", { staticClass: "secondary-text" }, [
                          _vm._v(_vm._s(scope.row.fileSizeStr)),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "exportConditionSummary",
              label: "导出条件",
              "min-width": "260",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "operateUser",
              label: "操作人",
              width: "110",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "createTime",
              label: "创建时间",
              width: "165",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "completeTime",
              label: "完成时间",
              width: "165",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "errorMessage",
              label: "失败原因",
              "min-width": "190",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              width: "150",
              fixed: "right",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.status === "COMPLETED"
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.downloadFile(scope.row)
                              },
                            },
                          },
                          [_vm._v("下载")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.status === "WAITING"
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "text",
                              loading: _vm.isActionLoading(scope.row),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleCancel(scope.row)
                              },
                            },
                          },
                          [_vm._v("取消")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.status === "PROCESSING"
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "text",
                              loading: _vm.isActionLoading(scope.row),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleStop(scope.row)
                              },
                            },
                          },
                          [_vm._v("中止")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.pagination.total > 0
        ? _c("el-pagination", {
            staticClass: "pagination",
            attrs: {
              "current-page": _vm.pagination.page,
              "page-size": _vm.pagination.limit,
              "page-sizes": [10, 20, 50],
              total: _vm.pagination.total,
              layout: "total, sizes, prev, pager, next",
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handlePageChange,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }